// extracted by mini-css-extract-plugin
module.exports = {"desktop_only":"(min-width: 1024px)","startSearch":"startSearch-3Ahpq","startSearch_iconMode":"startSearch_iconMode-3cVzr"};